<template>
    <div>
        <div class="white-box mt-3">
            <div class="data-group">
                <div class="flex flex-end">
                    <!--<h2 class="info-text">Am identificat 3 asociați - persoane fizice & 1 asociat companie</h2>-->
                    <M3FormTitle title="Asociați" :checked="completed"></M3FormTitle>
                </div>
                <div class="adauga-asociat align-end">
                    <div class="add-button" @click="toggleAdd()">
                        <p id="v-step-1">Adaugă un asociat nou</p>
                        <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
                    </div>
                    <div class="mt-3">
                        <b-form-select v-if="adaugaAsociat" v-model="adaugaAsociatTip" :options="tipAsociat" @change="addAssociate(adaugaAsociatTip)"></b-form-select>
                    </div>
                </div>

                <validation-observer #default="{ invalid }" ref="observer">
                    <span class="display-none">{{ invalid }}</span>
                    <b-form>
                        <div v-for="(asociat, key) in form.associates" :key="key" class="asociat mt-4">
                            <div v-if="asociat.tip === 1" class="flex flex-end mb-1 responsive-redefine">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Societate"
                                        class="has-icon custom-responsive"
                                    >
                                        <b-form-input
                                            id="company_name"
                                            v-model="asociat.companie"
                                            type="text"
                                            name="company_name"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="second-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="CUI"
                                        class="has-icon custom-responsive"
                                    >
                                        <b-form-input
                                            id="business_id"
                                            v-model="asociat.cui"
                                            type="text"
                                            name="business_id"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex flex-end mb-1 responsive-redefine">
                                <validation-provider
                                    v-if="asociat.tip == 0"
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Nume și prenume"
                                        class="has-icon custom-responsive"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="asociat.name"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    v-if="asociat.tip == 1"
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Reprezentant legal"
                                        class="has-icon custom-responsive"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="asociat.name"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="second-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="Cetățenie"
                                        class="has-icon custom-responsive"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="asociat.citizenship"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex flex-end mb-1 responsive-redefine">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Data și locul nașterii"
                                        class="has-icon custom-responsive"
                                    >
                                        <b-form-input
                                            id="birthdate_place"
                                            v-model="asociat.birthdate_place"
                                            type="text"
                                            name="birthdate_place"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="second-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        class="custom-responsive"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="Sex"
                                    >
                                        <b-form-select
                                            v-model="asociat.gender"
                                            :options="sexTypes"
                                            :state="errors.length > 0 ? false : null"
                                            :disabled="completed"
                                            :class="completed ?'disabled-select':''"
                                        >
                                        </b-form-select>
                                        <small class="text-danger" style="position: relative !important;">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex flex-end mb-1 responsive-redefine">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Aport la capital"
                                        class="has-icon custom-responsive"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="asociat.capital_contribution"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="second-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="Capital social"
                                        class="has-icon custom-responsive"
                                    >
                                        <b-form-input
                                            id="name"
                                            :ref="`aport${key}`"
                                            v-model="asociat.social_capital"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @focusout="formattedAport(key)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex space-between flex-start responsive-redefine">
                                <div class="first-input flex space-between align-center flex-start asociati-first-input">
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="CNP"
                                        class="cnp-responsive"
                                        style="width: 70%;"
                                    >
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            label-cols-lg="4"
                                            content-cols-lg="8"
                                            label="Cod numeric personal"
                                            class="has-icon custom-responsive"
                                            style="margin-left: 15px; margin-bottom: 0;"
                                        >
                                            <b-form-input
                                                id="name"
                                                v-model="asociat.cnp"
                                                type="number"
                                                name="message"
                                                :state="errors.length > 0 ? false : null"
                                                :readonly="completed"
                                            ></b-form-input>
                                            <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </b-form-group>

                                    </validation-provider>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        style="width: 30%;"
                                    >
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            label-cols-lg="4"
                                            content-cols-lg="8"
                                            label="Tip ID"
                                            class="custom-responsive"
                                        >
                                            <v-select
                                                v-model="asociat.id_type"
                                                dir="ltr"
                                                :options="idTypes"
                                                label="text"
                                                :reduce="(option) => option.value"
                                                input-id="id_series"
                                                :clearable="false"
                                                :disabled="completed"
                                                class="selected-hidden"
                                                :class="completed ?'disabled-select':''"
                                            ></v-select>
                                            <small class="text-danger" style="position: relative !important;">{{ errors[0] }}</small> </b-form-group>
                                    </validation-provider>
                                </div>
                                <div class="flex space-between align-center w-40" style="width: 32%;">
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        class="second-input w-48"
                                        style="width: 50%;"
                                    >
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            label-cols-lg="4"
                                            content-cols-lg="8"
                                            label="Serie ID"
                                            class="custom-responsive"
                                        >
                                            <b-form-input
                                                id="id_series"
                                                v-model="asociat.id_series"
                                                type="text"
                                                name="id_series"
                                                :state="errors.length > 0 ? false : null"
                                                :readonly="completed"
                                            >
                                            </b-form-input>
                                            <small class="text-danger" style="position: relative !important;">{{ errors[0] }}</small></b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        class="second-input"
                                        style="width: 50%;"
                                    >
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            label-cols-lg="4"
                                            content-cols-lg="8"
                                            label="Nr"
                                            class="has-icon custom-responsive"
                                        >
                                            <b-form-input
                                                id="name"
                                                v-model="asociat.id_no"
                                                type="text"
                                                name="message"
                                                :state="errors.length > 0 ? false : null"
                                                :readonly="completed"
                                            ></b-form-input>
                                            <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                            <small class="text-danger" style="position: relative !important;">{{ errors[0] }}</small>
                                        </b-form-group>

                                    </validation-provider>
                                </div>
                            </div>
                            <div class="flex flex-end mb-1 responsive-redefine">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Eliberat de"
                                        class="has-icon custom-responsive"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="asociat.id_released_by"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="second-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="Eliberat la"
                                        class="has-icon custom-responsive"
                                    >
                                        <b-form-datepicker
                                            :id="'eliberatLa'+key"
                                            v-model="asociat.id_released_at"
                                            class="w-100"
                                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                            locale="ro"
                                            :max="max"
                                            placeholder="Selectează o dată"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            :class="{ 'completed': completed }"
                                        ></b-form-datepicker>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <b-icon-x font-scale="1.7" class="delete-icon" @click="deleteAssociate(key)"></b-icon-x>
                        </div>
                        <div v-if="form.associates !== undefined && form.associates.length > 1" class="adauga-asociat align-end mt-4 mb-4">
                            <div class="add-button" @click="toggleAdd()" >
                                <p>Adaugă un asociat nou</p>
                                <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
                            </div>
                            <div class="mt-3">
                                <b-form-select v-if="adaugaAsociat" v-model="adaugaAsociatTip" :options="tipAsociat" @change="addAssociate(adaugaAsociatTip)"></b-form-select>
                            </div>
                        </div>
                        <hr class="mt-5">
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box"
                            @change="completeForm()"
                        >Informațiile sunt complete și corecte</b-form-checkbox>
                    </b-form>
                </validation-observer>
            </div>
            <a href="https://termene.ro/" target="_blank">
                <img src="@/assets/images/M3/M3Sketch/termenesmall.png" class="termene-icon">
            </a>
        </div>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormGroup, BButton, BFormCheckbox, BFormSelect, BIconX, BIconPlusCircleFill, BFormDatepicker } from 'bootstrap-vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    import M3FormTitle from '../M3FormTitle'
    import serii from '@/pages/Aplicatii/M3/M3Sketch/serii'
    import vSelect from "vue-select";
    import vCombobox from "vue-select";


    import "vue-select/dist/vue-select.css";

    export default {
        components: {
            BForm,
            BFormInput,
            BFormGroup,
            BButton,
            BFormCheckbox,
            M3FormTitle,
            BFormSelect,
            BIconX,
            BIconPlusCircleFill,
            BFormDatepicker,
            ValidationProvider,
            ValidationObserver,
            vSelect,
            vCombobox
        },

        props: {
            associates: [],
            activeCompany: null,
            associatesCompleted: null,
        },

        data() {
            return {
                form: {
                    associates: []
                },
                max: new Date(new Date().getTime()+(4*24*60*60*1000)),
                completed: false,
                idTypes: [
                    { value: 'CI', text: 'CI' },
                    { value: 'BI', text: 'BI' },
                    { value: 'PERMIS CONDUCERE', text: 'PERMIS CONDUCERE' },
                    { value: 'PAȘAPORT', text: 'PAȘAPORT' },
                    { value: 'CERTIFICAT DE NAȘTERE', text: 'CERT. NAȘTERE' },
                ],
                sexTypes: [
                    { value: 'feminin', text: 'Feminin' },
                    { value: 'masculin', text: 'Masculin' },
                ],
                idSeries: serii,
                asociatNew: null,
                adaugaAsociat: false,
                adaugaAsociatTip: null,
                tipAsociat: [
                    { value: null, text: 'Selectează un tip' },
                    { value: 'persoana', text: 'Persoană fizică' },
                    { value: 'firma', text: 'Persoană juridică' },
                ]
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            }
        },
        watch: {
            'associates': {
                handler: function(data) {
                    if(data && data.length > 0) {
                        this.form.associates = data;
                    }

                },
                immediate: true
            },

            completed(newValue, oldValue){
                if(newValue !== oldValue){
                    this.completed = newValue;
                    if(this.completed){
                        this.$emit('formComplete');
                    }
                    else{
                        this.$emit('formIncomplete');
                    }
                }
            },

            checks: {
                handler: function() {
                    this.completed = this.checks.companiaMeaAsociati;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
        },

        mounted() {
            if(this.associates && this.associates.length > 0) {
                this.form.associates = this.associates;
            }
        },

        methods: {
            formattedAport(key) {
                if(!this.form.associates[key].social_capital.includes('%')) {
                    this.form.associates[key].social_capital =  this.form.associates[key].social_capital + '%'
                }
                let aports = this.form.associates.map(data => {
                    return data.social_capital.replace('%', '')
                })
                let sum = aports.reduce(function(prev, curr){
                    return (Number(prev) || 0) + (Number(curr) || 0);
                });
                if(sum != 100) {
                    this.$swal({
                        heightAuto: false,
                        title: `Capitalul social ${sum > 100  ?'depășește':'nu este egal cu'} 100%.<br>Ești sigur că vrei să continui?`,
                        icon: 'warning',
                        confirmButtonText: 'Salvează',
                        showDenyButton: true,
                        denyButtonText: 'Anulează'
                    }).then((result) => {
                        if (!result.isConfirmed) {
                            this.$refs[`aport${key}`][0].$el.focus()
                        }
                    })
                }
            },
            completeForm() {

                if(this.form.associates.length === 0){
                    this.completed = false
                    this.$toast.error('Te rugăm adaugă un asociat.');
                }
                else {
                    this.$refs.observer.validate().then((e) => {
                        if(!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            if(this.completed){
                                this.form.associates.forEach(asociat => {
                                    asociat.id_series = asociat.id_series.toUpperCase()
                                })
                                this.$store.dispatch('m3Sketch/saveAllDataPart', this.form)
                                    .then((response) => {
                                        this.$toast.success(response.data.message)
                                    }).catch((xhr) => {
                                        if (xhr.status === 422) {
                                            this.errors.record(xhr.responseJSON.errors);
                                        }
                                        this.$toast.error(xhr.response.data.message);
                                    });
                            }
                        }
                        if(this.checks.companiaMeaAsociati !== this.completed)
                            this.$store.dispatch('checks/updateChecks', { name: 'companiaMeaAsociati', value: this.completed })
                    })

                }
            },

            deleteAssociate(event) {
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else if (this.form.associates.length < 2) {
                    this.$swal({
                        heightAuto: false,
                        title: 'Ești sigur că vrei să ștergi ultimul asociat?.<br>' +
                            '<p style="font-size: 14px; text-align: center; margin-top: 15px;">Compania trebuie să aibă minim un asociat</p>',
                        icon: 'info',
                        buttons: true,
                        confirmButtonText: 'Șterge',
                        showDenyButton: true,
                        denyButtonText: 'Anulează'
                    }).then((response) => {
                        if(response.value === true)
                            this.form.associates.splice(event, 1)
                    })
                } else {
                    this.form.associates.splice(event, 1)
                }
            },

            addAssociate() {
                let associate = {
                    name: '',
                    birthdate_place: '',
                    citizenship: '',
                    gender: '',
                    social_capital: '',
                    capital_contribution: '',
                    cnp: '',
                    id_type: '',
                    id_series: '',
                    id_no: '',
                    id_released_by: '',
                    id_released_at: '',
                    companie: '',
                    cui: '',
                    tip: this.adaugaAsociatTip === 'firma' ? 1 : 0,
                }

                this.form.associates.push(associate)
                this.adaugaAsociatTip = null
                this.adaugaAsociat = false
                this.$emit('associateAdded', this.form.associates);
                this.$toast.success('Asociatul a fost adăugat cu succes!');
            },
            toggleAdd() {
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else{
                    this.adaugaAsociat = this.adaugaAsociat !== true;
                }

            }
        },
    }
</script>

<style scoped>
.text-danger{
    position: absolute;
    white-space: pre;
}
.flex{
    display: flex;
}
.align-end{
    text-align: end;
}
.flex-end{
    justify-content: flex-end;
}
.adauga-asociat{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.flex-start{
    align-items: flex-start;
}
.adauga-asociat select{
    width: 220px;
}
.first-input{
    width: 60%;
}
.info-text{
    font-size: 19px;
    margin: 0;
    color: #01e8c6;
    opacity: 0.7;
}
.space-between{
    justify-content: space-between;
}
.second-input{
    width: 40%;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 90%;
}
.switch-box{
    text-align: right;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.form-group >>> legend{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.v-select >>> .vs__dropdown-menu {
    background: #e9ecef;
    max-height: 200px;
    overflow-y: hidden;
}
.v-select >>> .vs__dropdown-toggle{
    background: #e9ecef;
    margin: 0;
    border-radius: 2px;
    justify-content: space-between;
    align-items: center;
    max-height: 33px;
}
.v-select >>> .vs__actions{
    padding: 0;
}
.v-select >>> .vs__dropdown-option {
    color: #767a95;
    font-size: 13px;
    padding-left: 5px;
    font-weight: 600;
}
.v-select >>> .vs__search{
    margin: 0;
    padding: 0;
}
.v-select >>> .vs__selected{
    color: #767a95;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.inline-inputs{
    display: flex;
}
.inline-inputs input:first-child, .inline-inputs div:first-child{
    width: 25%;
    margin-right: 10px;
}
.inline-inputs dfiv:first-child input{
    width: 100%;
}
.has-icon{
    position: relative;
}
.has-icon img{
    position: absolute;
    top: 10px;
    right: 20px;
    opacity: 0.3;
}
.termene-icon{
    position: absolute;
    bottom: 15px;
    left: 20px;
}
.custom-select{
    color: #767a95;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 2px;
    max-height: 33px;
    margin: 0 !important;
    font-weight: 600;
    background: #e9ecef url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
}
.disabled-select{
    background: #a1fff1 url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
}
.disabled-select >>> .vs__dropdown-toggle{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
.v-select >>> .vs__selected-options {
    flex-wrap: nowrap;
    max-width: calc(100% - 41px);
}
.v-select >>> .vs__selected {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
    margin-top: 2px;
}
.disabled-select >>> input{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
.asociat{
    position: relative;
}
.asociat:not(:first-child){
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding-top: 35px;
}
.delete-icon{
    position: absolute;
    top: 40%;
    right: -5%;
    cursor: pointer;
}
.delete-icon:hover{
    color: red;
}

.b-form-datepicker{
    color: #767a95;
    background: #e9ecef;
    font-size: 14px;
    font-weight: 700;
    padding: 0;
    max-height: 33px;
    border-radius: 2px;
}
.completed{
    background: #d1f5ea!important;
    color:#b2b6be!important;
    pointer-events: none;
}
.custom-select{
    -moz-appearance: none !important;
    -webkit-appearance: none !important;
    appearance: none !important;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
    .delete-icon{
        right: -30px;
    }
}
@media (max-width: 1300px){
    .disabled-select >>> input{
        display: none;
    }
}
@media (max-width: 1550px){
    .text-danger{
        white-space: inherit;
    }
}
</style>
